import {Configuration} from "types/configurations";

export const isConfigurationValueTrue = (config: Configuration | undefined) => {
    return config?.value === "true";
};
